document.addEventListener('app:load', init)

function init ()
{
	if (!document.body.classList.contains('page-template-rendez-vous'))
	{
		return
	}
	
	const showAgenda = document.querySelector('main .button.show-agenda')
	const agenda = document.querySelector('main div[data-rgpd]')
	const closeAgenda = agenda.querySelector('.close')
	
	showAgenda.addEventListener('click', (e) => {
		e.preventDefault()
		
		agenda.classList.add('visible')
	})
	
	closeAgenda.addEventListener('click', () => {
		agenda.classList.remove('visible')
	})
}
